<lib-modal-container
class="bootstrap-wrapper"
[modalTitle]="'Vista previa del archivo'"
[hideSave]="true"
cancelText="Cerrar"
(dismiss)="handleClose()"
>
<iframe
*ngIf="fileUrl"
[src]="fileUrl"
width="100%"
height="900"
alt="Pdf"
frameborder="0"></iframe>
</lib-modal-container>